import { ThingsCurrentStates } from './thingsCurrentState';

export class ThingControl{
    macId: string;
    controlIdentifier :string;
    type: string;
    topic: string;
    states: Array<Map<string, [string]>>;
    accessoryIdentifier: string;
    displayName: string;
    iconType: string;
    hasControlImage: boolean;
    isConfirmationRequire: boolean;
    linkIconType: string;
    linkDisplayName: string;

    constructor (macId: string,
        controlIdentifier :string,
        type: string,
        topic: string,
        states: Array<Map<string, [string]>>,
        accessoryIdentifier: string,
        displayName: string,
        iconType: string,
        hasControlImage: boolean,
        isConfirmationRequire: boolean,
        linkIconType: string,
        linkDisplayName: string){
            this.macId = macId;
            this.controlIdentifier = controlIdentifier;
            this.type = type;
            this.topic = topic;
            this.states = states;
            this.accessoryIdentifier = accessoryIdentifier;
            this.displayName = displayName;
            this.iconType = iconType;
            this.hasControlImage = hasControlImage;
            this.isConfirmationRequire = isConfirmationRequire;
            this.linkIconType = linkIconType;
            this.linkDisplayName = linkDisplayName;
        }

}